(function (window, document, $) {
    'use strict';

    $(function () {
        $('main').on('click', '.btn-open-table-modal', function() {
            let detail = $(this).data('detail');
            $('.modal-body').load(vehicletree.resturl + 'garage-services/v1/detail/' + detail,
                function () {
                    $('#table-modal').modal({show: true});
                });
        });
    });
}(window, document, jQuery));